
import { ActionType } from 'store/customers/types'
import type { CreateLeanCustomerPayload, GetCustomerByIdPayload, GetCustomersPayload, UpdateCustomerPayload } from 'store/customers/types'
import { ActionCallback, IValidationCallback } from 'store/model'

export const getCustomers = (payload: GetCustomersPayload, callback: IValidationCallback): ActionCallback<GetCustomersPayload> => ({
  type: ActionType.GET_CUSTOMERS,
  payload,
  callback,
})

export const getCustomerById = (payload: GetCustomerByIdPayload, callback: IValidationCallback): ActionCallback<GetCustomerByIdPayload> => ({
  type: ActionType.GET_CUSTOMER,
  payload,
  callback,
})

export const createCustomer = (payload: CreateLeanCustomerPayload, callback: IValidationCallback): ActionCallback<CreateLeanCustomerPayload> => ({
  type: ActionType.CREATE_CUSTOMER,
  payload,
  callback,
})

export const updateCustomer = (payload: UpdateCustomerPayload, callback: IValidationCallback): ActionCallback<UpdateCustomerPayload> => ({
  type: ActionType.UPDATE_CUSTOMER,
  payload,
  callback,
})
